module.exports = require('./helpers/bundle-url').getBundleURL('jFbuv') + "logo.c51670a8.svg";